const mutationTypes = {
  SET_DISPOSE: 'dispose',
  SET_FILTER: 'setFilter',
  SET_ACADEMIC_YEAR: 'setAcademicYear',
  SET_MONTH: 'setMonth',
  SET_SERVICE_LOCATION: 'setServiceLocation',
  SET_SPECIALIST: 'setSpecialist',
  SET_ACTIVITY: 'setActivity',
  SET_CENTER: 'setCenter',
  SET_SEARCH_CONSULTING: 'setSearchConsulting',
  SET_PROVIDER: 'setProvider',
  SET_FINALIZED_BILLING_STATUS: 'setFinalizedBillingStatus',
};

export default mutationTypes;
